import * as analyticsActions from '~/actions/analytics.actions';
import { ActionKeys } from '~/actions/constants';
import { AxiosResponse } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as analyticsService from '~/services/analytics.service';
import * as metrics from '~/types/Metrics';

export function* fetchMetrics(action: ReturnType<typeof analyticsActions.fetchMetrics>) {
  try {
    const startDate = action.payload.startDate;
    const endDate = action.payload.endDate;
    const response: AxiosResponse<{ data: metrics.JSONMetrics }> = yield call(
      analyticsService.getMetrics,
      startDate,
      endDate,
    );
    const data = metrics.fromJSON(response.data.data);
    yield put(analyticsActions.fetchMetricsSuccess(data));
  } catch (err) {
    yield put(analyticsActions.fetchMetricsError());
  }
}

export default [takeLatest(ActionKeys.ANALYTICS_FETCH_METRICS, fetchMetrics)];
